import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CMSService } from '../Services/cms.service';
import { CmsLoginHeaderProperties } from '../Models/CmsLoginHeaderProperties';
import { CMSComponent } from '../cms/cms.component';
import { Route, Router } from '@angular/router';
import { BeneficiaryService } from '../Services/beneficiary.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-cms-sub-header',
  templateUrl: './cms-sub-header.component.html',
  styleUrls: ['./cms-sub-header.component.css']
})
@NgModule({ imports: [FormsModule] })

export class CmsSubHeaderComponent {
  //@Output() public onUploadFinished = new EventEmitter();
  header: {};
  //headerDataById: CmsLoginHeaderProperties[] = [];
  constructor(private userService: CMSService, private http: HttpClient, private router: Router, private beneficiaryService: BeneficiaryService) { };
  cmsLoginHeaderObj = new CmsLoginHeaderProperties();

 // cmsComopnentObj = new CMSComponent(this.userService, this.http, this.router, this.beneficiaryService);
  
  public progress: number;
  public imagePath: any;
  public imageSPath: any;
  /*public jsonObject: any;*/
  public message: string;
  public logoPath: string;
  public responseMessage: string;

  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0 || sr != undefined) {
          this.userService.getHeaderById(sr).subscribe((data) => {
            this.cmsLoginHeaderObj = data[0] as CmsLoginHeaderProperties;
            localStorage.removeItem("serialNo");
          });
        }
      }
    }
    catch (e) {
      //console.log(e);
    }
  }
  onSubmit() {
    if (this.cmsLoginHeaderObj.sr == 0 || this.cmsLoginHeaderObj == null) {
      this.userService.createHeader(this.cmsLoginHeaderObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    else {
      this.userService.updateHeader(this.cmsLoginHeaderObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }

    
  }
  cancel() {
    this.cmsLoginHeaderObj = new CmsLoginHeaderProperties();
  }
    
}
